var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 12.5H7.50016V10.8333H13.3335V12.5ZM15.8335 9.16667H7.50016V7.5H15.8335V9.16667ZM15.8335 5.83334H7.50016V4.16667H15.8335V5.83334ZM2.50016 4.16667V17.5H15.8335V19.1667H2.50016C2.05814 19.1667 1.63421 18.9911 1.32165 18.6785C1.00909 18.366 0.833496 17.942 0.833496 17.5V4.16667H2.50016ZM17.5002 0.833336C17.9422 0.833336 18.3661 1.00893 18.6787 1.32149C18.9912 1.63405 19.1668 2.05797 19.1668 2.5V14.1667C19.1668 15.0917 18.4252 15.8333 17.5002 15.8333H5.8335C5.39147 15.8333 4.96755 15.6577 4.65498 15.3452C4.34242 15.0326 4.16683 14.6087 4.16683 14.1667V2.5C4.16683 1.575 4.9085 0.833336 5.8335 0.833336H17.5002ZM5.8335 2.5V14.1667H17.5002V2.5H5.8335Z",
    fill: "#0D2548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.19dd210782b75e3b49f8640e3f2cb2f7.svg";
export { ForwardRef as ReactComponent };